import { css } from '@emotion/react'
import { Card, colors } from 'plume-ui'
import React, { useEffect, useState } from 'react'
import { CardInnerTitle } from '../../../../atoms/CardInnerTitle'
import { EmptyCard } from '../../../../common/EmptyCard'
import { NewsPicksFeedSearchResultItem } from '../../../../common/npStartup/NewsPicksSearchResult'
import { NPFeedSearchResult } from 'types'
import { fetchNPFeedsByCompanyShortname } from '@/lib/api/np/feed'
import { printError } from '@/lib/log'

type Props = {
  shortname: string
  className?: string
}

export const CompanyNewsPicksFeeds: React.VFC<Props> = (props) => {
  const [npFeeds, setNpFeeds] = useState<NPFeedSearchResult[] | null>(null)

  useEffect(() => {
    setNpFeeds(null)
    fetchNPFeedsByCompanyShortname(props.shortname)
      .then((r) => {
        setNpFeeds(r)
      })
      .catch((e) => printError(e))
  }, [props.shortname])

  const className = props.className
    ? [props.className, 'np-feeds'].join(' ')
    : 'np-feeds'

  if (!npFeeds) return null

  const newsPicksFeeds = npFeeds.slice(0, 10)
  return (
    <div className={className}>
      <Card>
        <CardInnerTitle
          title="NewsPicksの検索結果"
          helpText="検索結果について"
          helpLink="https://help.initial.inc/ja/articles/5676034"
        />
        <div
          css={css`
            & > :not(:last-child) {
              border-bottom: 1px solid ${colors.gray50};
            }
          `}
        >
          {npFeeds.length === 0 ? (
            <EmptyCard />
          ) : (
            newsPicksFeeds.map((feed, i) => (
              <NewsPicksFeedSearchResultItem
                key={i}
                index={i + 1}
                {...feed}
                classPrefix="companypage"
              />
            ))
          )}
        </div>
      </Card>
    </div>
  )
}
